



























import { Component, Watch } from 'vue-property-decorator';
import { RolesModule } from '@/store/Settings/RolesModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PageNames from '@/router/PageNames';
import Role from '@/models/Settings/Roles/Role';
import RoleCreate from '@/components/Settings/Roles/RoleCreate.vue';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'Roles', components: { Alert, RoleCreate }, metaInfo: { title: 'Roles' } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    headers = [
        { text: this.$t('pageText.roles.fields.name'), sortable: false, width: "50%" },
        { text: this.$t('pageText.roles.fields.id'), sortable: false, width: "50%" }
    ];
    rolesPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.rolesPage = +page;
        }
    }

    async beforeMount() {
        await RolesModule.getRoles();
    }

    get roles() {
        return RolesModule.roles;
    }

    get totalRolesPages() {
        return RolesModule.totalRolesPages;
    }

    get loading() {
        return RolesModule.loading;
    }

    get pageSize() {
        return RolesModule.pageSize;
    }

    @Watch('rolesPage')
    async onRolesPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.rolesPage}` } });
    }

    async navigateToRole(role: Role) {
        this.$router.push({ name: PageNames.Role, params: { id: role.id }, query: { tab: "0" } });
    }

}
